import {FC, Form} from 'external/react'
import {PasswordField } from 'components/FormTextfield'
import useParent from 'context/parent-context/hook'

type UpdatePasswordFormProps =  {
	errors: any
}

const UpdatePasswordForm: FC<UpdatePasswordFormProps> = props => {

	const {errors} = props

    const {update, state: {modals: {updatePassword: {passwords}}}} = useParent()

	function createFieldProps (placeholder: any, fieldName: string | number, maxLength?: any) {
		return {
			placeholder,
			maxLength,
			fieldName,
			value: passwords[fieldName],
			submitted: errors.submitted,
			error: errors[fieldName],
			onChange: (e: { target: { value: string } }) => {
				update({modals: {updatePassword: {passwords: {[fieldName]: {$set: e.target.value}}}}})
			}
		}
	}

    return (
        <Form>
           <PasswordField className='col-sm-6' controlProps={{autoComplete: 'current-password'}} {...createFieldProps('Contraseña actual', 'oldPassword')} />
           <PasswordField className='col-sm-6 mt-3' controlProps={{autoComplete: 'new-password'}} {...createFieldProps('Contraseña nueva', 'password')} />
           <PasswordField className='col-sm-6 mt-3' controlProps={{autoComplete: 'new-password'}} {...createFieldProps('Confirmar Contraseña', 'confirmPassword')} />
        </Form>
    )
}

export {UpdatePasswordForm as default}